// this file is generated by update_shopify_store_data.py at 2026-02-23 20:30:43.747090
var courses = [];